import TaskItem from "../../../components/list/TaskItem";

function DisplayTable({ list, listLabel, listCheckList, editHandler, idTab }) {

    return (
        <>
            {list.map((item) => (
                <TaskItem key={item.ID + '_' + item.ID_User}
                    idObject={1}
                    item={item}
                    editHandler={editHandler}
                    listLabel={listLabel.filter(a => a.ID_Item === item.ID)}
                    showCheckList={true}
                    listCheckList={listCheckList.filter(a => a.ID_Item === item.ID)}
                    showPercent={idTab != 5 ? true : false}
                    showUser={idTab === 4 ? true : false}
                    listUser={[{ ID_User: item.ID_User, ID_Action: item.ID_Action }]}
                    showDateStartEnd={true}
                />
            ))}
            {/*stateSize.windowWidth > 1000 ? (list.map((item) => (
                <div key={item.ID} className={"list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                    <div style={{ width: '50%' }}>
                        <div className='title' >{item.Name} {item.Viewed === false && <span className="badge badge-menu warning badge-dot ml-5"> </span>}</div>
                        <div className='subtitle'>{item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}</div>
                        {<div><small><DateStartEndForList date_start={item.Date_Start} date_end={item.Date_End} /></small></div>}
                        <div className="badge_block">
                            {
                                listLabel.filter(a => a.ID_Item === item.ID).map((label) => (
                                    <div key={label.ID_Label} className="badge_item" style={{ backgroundColor: label.Color }} >
                                        {label.Name}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="center" style={{ width: '300px' }}>
                        {idTab === 4 && (
                            stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 &&
                            <div className="d-flex align-items-center mr-30">
                                <div className="mr-5"><AvatarRound img={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small} width={30} name={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User.charAt(0)} /></div>
                                {stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User}
                            </div>
                        )}
                    </div>
                    <div className="center" style={{ width: '80px' }}>
                        {listCheckList.filter(a => a.ID_Item === item.ID).length > 0 &&
                            (
                                <>
                                    <div>
                                        <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                    </div>
                                    <div>
                                        <b>{listCheckList.filter(a => a.ID_Item === item.ID & a.Completed == true).length}</b>
                                        /
                                        <b>{listCheckList.filter(a => a.ID_Item === item.ID).length}</b>
                                    </div>
                                </>
                            )}
                    </div>
                    <div className="end" style={{ width: '50px' }}>
                        <div style={{ display: "inline-block" }}>
                            {idTab != 5 && (
                                item.ID_Type === 2 &&
                                <PercentSuccessV2 percent={item.Percent} />
                            )}
                        </div>
                    </div>
                </div>
            ))) : (

                list.map((item) => (
                    <div key={item.ID} className={"m_list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                        <div style={{ width: '100%' }}>
                            <div className='title' >{item.Name} {item.Viewed === false && <span className="badge badge-menu warning badge-dot ml-5"> </span>}</div>
                            <div className='subtitle'>{item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}</div>


                        </div>
                        <div className="badge_block" >
                            {
                                listLabel.filter(a => a.ID_Item === item.ID).map((label) => (
                                    <div key={label.ID_Label} className="badge_item" style={{ backgroundColor: label.Color }} >
                                        {label.Name}
                                    </div>
                                ))
                            }
                        </div>
                        <div className="mt-5"><DateStartEndForList date_start={item.Date_Start} date_end={item.Date_End} /></div>
                        <div className="mt-5">
                            {idTab === 4 && (
                                stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 &&
                                <div className="d-flex align-items-center mr-30 mt-5 mb-5">
                                    <div className="mr-5"><AvatarRound img={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small} width={25} name={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User.charAt(0)} /></div>
                                    {stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User}
                                </div>
                            )}
                        </div>
                        <div className="mt-5">
                            {listCheckList.filter(a => a.ID_Item === item.ID).length > 0 &&
                                (
                                    <>

                                        <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />

                                        <b>{listCheckList.filter(a => a.ID_Item === item.ID & a.Completed == true).length}</b>
                                        /
                                        <b>{listCheckList.filter(a => a.ID_Item === item.ID).length}</b>

                                    </>

                                )}
                        </div>

                        {idTab != 5 && (
                            <div className="mt-5">
                                {
                                    item.ID_Type === 2 &&
                                    <PercentSuccessV2 percent={item.Percent} />
                                }
                            </div>
                        )}

                    </div>
                ))
            )*/}

        </>)
}


export default DisplayTable;